import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/apiClient";

const StoreContext = createContext(null);
export const useStore = () => useContext(StoreContext);

const load = (k, d) => {
  try {
    const v = localStorage.getItem(k);
    return v ? JSON.parse(v) : d;
  } catch {
    return d;
  }
};

export function StoreProvider({ children }) {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [settings, setSettings] = useState(null);
  const [cart, setCart] = useState(() => load("ata_cart", []));
  const [delivery, setDelivery] = useState(() => load("ata_delivery", null)); // {mode, postal_code, timeslot}
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([api.get("/products"), api.get("/settings"), api.get("/categories")])
      .then(([p, s, c]) => {
        setProducts(p.data);
        setSettings(s.data);
        setCategories(c.data);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => localStorage.setItem("ata_cart", JSON.stringify(cart)), [cart]);
  useEffect(() => {
    if (delivery) localStorage.setItem("ata_delivery", JSON.stringify(delivery));
  }, [delivery]);

  const refreshProducts = useCallback(() => api.get("/products").then((r) => setProducts(r.data)), []);

  const addToCart = useCallback((item) => {
    setCart((c) => [...c, { ...item, uid: `${Date.now()}-${Math.random().toString(36).slice(2, 7)}` }]);
  }, []);

  const updateQty = useCallback((uid, qty) => {
    setCart((c) => (qty <= 0 ? c.filter((i) => i.uid !== uid) : c.map((i) => (i.uid === uid ? { ...i, qty } : i))));
  }, []);

  const removeItem = useCallback((uid) => setCart((c) => c.filter((i) => i.uid !== uid)), []);
  const clearCart = useCallback(() => setCart([]), []);

  const itemUnitPrice = (i) => i.base_price + (i.selected_addons || []).reduce((s, a) => s + a.price, 0);
  const cartCount = cart.reduce((s, i) => s + i.qty, 0);
  const cartSubtotal = cart.reduce((s, i) => s + itemUnitPrice(i) * i.qty, 0);

  const value = {
    products, categories, settings, refreshProducts, loading,
    cart, addToCart, updateQty, removeItem, clearCart, cartCount, cartSubtotal, itemUnitPrice,
    delivery, setDelivery,
  };
  return <StoreContext.Provider value={value}>{children}</StoreContext.Provider>;
}
